import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from '../../components/Shared/Breadcrumb';
import Link from '../../components/Global/Link';
import Upload from '../../components/Upload';
import Loader from '../../components/Shared/Loader';
import { downloadAssets } from '../../services/CampaignInternalService';
import './index.scss';
import Hero from '../../components/Hero';
import Button from '../../components/Shared/Button';
import HeroImage from '../../assets/images/campainHero-image.svg';

const UploadCampaign = () => {
  const [showLoader, setShowLoader] = useState(false);

  // const downloadGuidelines = () => {
  //   setShowLoader(true);
  //   let fileName: string = 'Guidelines.zip';
  //   downloadAssets(fileName)
  //     .then(function (data) {
  //       const url = window.URL.createObjectURL(new Blob([data]));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //       setShowLoader(false);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //       setShowLoader(false);
  //     });
  // };

  return (
    <div className="uploadCampaign">
      <Container fluid="xl">
        <h2 className="pageTitle">Asset library</h2>
        <Upload></Upload>
        {showLoader ? <Loader /> : <></>}
      </Container>
    </div>
  );
};

export default UploadCampaign;
